export default __webpack_public_path__ + "static/media/ic_niue.891157e6.svg";